import {
    TOAST_INFO, TOAST_ERROR, TOAST_WARNING, TOAST_CLEAR,
    TOAST_SUCCESS, TOAST_SNACKBAR, SHOW_OVERLAY, HIDE_OVERLAY
} from '../constants/action-types';

export const toastSuccess = (message, options) => ({ type: TOAST_SUCCESS, message, options });

export const toastInfo = (message, options) => ({ type: TOAST_INFO, message, options });

export const toastError = (message, options) => ({ type: TOAST_ERROR, message, options });

export const toastWarn = (message, options) => ({ type: TOAST_WARNING, message, options })

export const toastSnackbar = (message, options) => ({ type: TOAST_SNACKBAR, message, options })

export const toastClear = () => ({ type: TOAST_CLEAR });

export const showOverlay = payload => ({ type: SHOW_OVERLAY, payload });

export const hideOverlay = () => ({ type: HIDE_OVERLAY });